import React from "react";

import Shell from 'components/layout/list/shell';
import Errors from 'components/error404';
import RedirectToDashBoard from './dashboard';

import OrgMain from 'components/orgs/list/main'
import OrgCreate from 'components/orgs/details/create';
import OrgDetails from 'components/orgs/details/details';
import OrgEdit from 'components/orgs/details/edit';

import DotResearch from "components/dotresearch/main";

import UsTiresMain from 'components/ustires/list/main'
import UsTiresCreate from 'components/ustires/details/create';
import UsTiresDetails from 'components/ustires/details/details';
import UsTiresEdit from 'components/ustires/details/edit';

import { PrivateDBRoutes } from 'components/privatedb/routes';
import { UserRoutes } from 'components/users/routes';
import TireRoutes from "components/tire/routes";
import LShell from "components/layout/list/logoutshell";
import PaymentRoutes from "components/subscription/router";
import Screenshots from "components/screenshots";

export function MainRoutes() {

  console.log('MainRoutes');

  return [
    {
      path: '/',
      element: (<Shell />),
      loader: RedirectToDashBoard,
      errorElement: <Errors />,
    },
    {
      path: '/privatedb',
      element: (<Shell />),
      errorElement: <Errors />,
      children: PrivateDBRoutes()
    },
    {
      path: '/tire',
      element: (<LShell />),
      errorElement: <Errors />,
      children: TireRoutes()
    },
    {
      path: '/dot',
      element: (<Shell />),
      errorElement: <Errors />,
      children: [
        {
          path: '/dot/research',
          element: (<DotResearch />),
          errorElement: <Errors />,
        }
      ]
    },

    {
      path: '/orgs',
      element: (<Shell />),
      errorElement: <Errors />,
      children: [
        {
          path: '/orgs/details/:userId',
          element: (<OrgDetails />),
          errorElement: <Errors />,
        },
        {
          path: '/orgs/edit/:id',
          element: (<OrgEdit />),
          errorElement: <Errors />,
        },
        {
          path: '/orgs/list',
          element: (<OrgMain />),
          errorElement: <Errors />,
        },
        {
          path: '/orgs/create',
          element: (<OrgCreate />),
          errorElement: <Errors />,
        }
      ]
    },
    {
      path: '/screenshots',
      element: (<Shell />),
      errorElement: <Errors />,
      children: [
        {
          path: '/screenshots/details',
          element: (<Screenshots />),
          errorElement: <Errors />,
        }
      ]
    },
    {
      path: '/ustires',
      element: (<Shell />),
      errorElement: <Errors />,
      children: [
        {
          path: '/ustires/details/:id',
          element: (<UsTiresDetails />),
          errorElement: <Errors />,
        },
        {
          path: '/ustires/edit/:id',
          element: (<UsTiresEdit />),
          errorElement: <Errors />,
        },
        {
          path: '/ustires/list',
          element: (<UsTiresMain />),
          errorElement: <Errors />,
        },
        {
          path: '/ustires/create',
          element: (<UsTiresCreate />),
          errorElement: <Errors />,
        }
      ]
    },
    {
      path: '/users',
      element: (<Shell />),
      errorElement: <Errors />,
      children: UserRoutes()
    },
    {
      path: '/payment',
      element: (<Shell />),
      errorElement: <Errors />,
      children: PaymentRoutes(),
    },
    {
      path: '*',
      element: (<Shell />),
      loader: RedirectToDashBoard,
      errorElement: RedirectToDashBoard,
    },
  ]
}

export default MainRoutes;